import { render, staticRenderFns } from "./estimate-item.vue?vue&type=template&id=385b7195&scoped=true"
import script from "./estimate-item.vue?vue&type=script&lang=js"
export * from "./estimate-item.vue?vue&type=script&lang=js"
import style0 from "./estimate-item.vue?vue&type=style&index=0&id=385b7195&prod&lang=css"
import style1 from "./estimate-item.vue?vue&type=style&index=1&id=385b7195&prod&lang=css"
import style2 from "./estimate-item.vue?vue&type=style&index=2&id=385b7195&prod&lang=css"
import style3 from "./estimate-item.vue?vue&type=style&index=3&id=385b7195&prod&lang=css"
import style4 from "./estimate-item.vue?vue&type=style&index=4&id=385b7195&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385b7195",
  null
  
)

export default component.exports